import { changedFields } from "./changedFields";

// What a settings change writes: only the fields that changed (Craig, 25 Oct 2026, "Yes, please", to every setting
// saving on its own; changedFields.js says why). `sortModes` and `lastResetDate` have their own writes and are never
// part of it. A field taken out of settings isn't removed from the stored document: nothing takes fields out.
const OWN_WRITES = ["sortModes", "lastResetDate"];

export const settingsPatch = (prev, next) => changedFields(prev, next, OWN_WRITES);
